import TspActionTypes from './tsp.types'

const INITIAL_STATE = {
  providers:[],
  selectedTsp: null
}

const tspReducer = (state=INITIAL_STATE, action) => {
  switch(action.type) {
    case TspActionTypes.FETCH_TSP_SUCCESS:
      return {
        ...state,
        providers: action.payload
      }
    case TspActionTypes.SELECT_TSP:
      return {
        ...state,
        selectedTsp: action.payload
      }
    default:
      return state
  }
}

export default tspReducer